import { render, staticRenderFns } from "./guide-info.vue?vue&type=template&id=65f1e59f&scoped=true&"
import script from "./guide-info.vue?vue&type=script&lang=js&"
export * from "./guide-info.vue?vue&type=script&lang=js&"
import style0 from "./guide-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./guide-info.vue?vue&type=style&index=1&id=65f1e59f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1e59f",
  null
  
)

export default component.exports